const React = require('react');
const { ThemeProvider } = require('./src/context/ThemeContext');

export const wrapRootElement = ({ element }) => <ThemeProvider>{element}</ThemeProvider>;
